/**
 * Routes where the cookie banner WAITS rather than shows (row db174b50).
 *
 * Every external meeting guest is a first-time visitor, so every one of them
 * met the banner, and at 1280x800 it sat over the guest page's Join button and
 * then over the meeting's control bar (Leave, mic, camera). Those pages are
 * full-height layouts (`h-screen`), so the `#root` padding the banner publishes
 * cannot move their controls out from under it; the only placement that never
 * overlaps is not showing it there.
 *
 * Deferring is safe for consent because the banner only asks about OPTIONAL
 * cookies, which stay off until a choice is stored (functional and analytics
 * default false, and nothing reads an undecided consent as yes).
 * Strictly-necessary cookies need no consent. So a guest in a meeting has no
 * optional cookie set, and the banner asks on their first page outside the
 * meeting.
 *
 *   /join/:meetingId                   the guest join page (App.tsx)
 *   /meeting/:meetingId[/lobby|/end]   the room, its lobby, the guest end page
 */
const DEFERRED_ROUTE = /^\/(join|meeting)\//;

export function bannerDeferredOn(pathname: string): boolean {
  return DEFERRED_ROUTE.test(pathname);
}
